import React, { useState, useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar_old";

import Footer from "./Footer";

import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap-icons/font/bootstrap-icons.css";

import axios from "axios";



const shuffleArray = (arr) => {

  return [...arr].sort(() => Math.random() - 0.5);

};



const Moreprofile = () => {

  const [chats, setChats] = useState([]);

  const [activeChat, setActiveChat] = useState(null);

  const [messages, setMessages] = useState([]);

  const [text, setText] = useState("");

  const [query, setQuery] = useState("");

  const [genderFilter, setGenderFilter] = useState("");

  const [likedProfiles, setLikedProfiles] = useState([]);

  const [fullscreenImage, setFullscreenImage] = useState(null);



  const messagesEndRef = useRef(null);

  const navigate = useNavigate();

const sortByOppositeGenderFirst = (profiles) => {

  if (!currentUser.gender) return profiles;



  const userGender = currentUser.gender; // male / female



  const oppositeGender =

    userGender === "male" ? "female" :

    userGender === "female" ? "male" :

    "";



  const top = profiles.filter(

    (p) => (p.gender || "").toLowerCase() === oppositeGender

  );



  const rest = profiles.filter(

    (p) => (p.gender || "").toLowerCase() !== oppositeGender

  );



  return [...top, ...rest];

};



  // ✅ Logged-in user

  const loggedUser = JSON.parse(localStorage.getItem("currentUser")) || null;

  // if (!loggedUser) {

  //   alert("User not found! Please login again.");

  //   navigate("/login");

  // }



const currentUser = {

  id: loggedUser?._id || 0,

  fullName: loggedUser?.full_name || loggedUser?.name || "Guest",

  // gender: (loggedUser?.gender || "").toLowerCase(), // 👈 ADD

  canChat: loggedUser?.can_chat || false,

  canCall: loggedUser?.can_call || false,

};





  const defaultAvatar =

    "https://cdn-icons-png.flaticon.com/512/149/149071.png";



  // Scroll to bottom on new messages

  useEffect(() => {

    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });

  }, [messages]);



// Fetch all registered users from backend

useEffect(() => {

  axios

    .get("https://rishtey.rishteymatch.in/api2/getActiveUsers")

    .then((res) => {

      if (res.data.success) {

        let formatted = res.data.users.map((u) => {

          let avatarUrl = defaultAvatar;

          if (u.image) {

            if (u.image.startsWith("http")) avatarUrl = u.image;

            else if (u.image.startsWith("/"))

              avatarUrl = `https://rishtey.rishteymatch.in${u.image}`;

            else avatarUrl = `https://rishtey.rishteymatch.in/${u.image}`;

          }



          return {

            id: u._id,

            fullName: u.full_name || u.name || "",

            state: u.user_state || u.state || "",

            city: u.city || "",

            age: u.age || "N/A",

            education: u.education || "",

            mobile: u.mobile || "",

            avatar: avatarUrl,

            gender: (u.gender || "").toLowerCase(),

            canChat: u.can_chat ?? false,

            canCall: u.can_call ?? false,

          };

        });



        // ✅ RANDOM ONLY ON PAGE LOAD / REFRESH

        formatted = shuffleArray(formatted);



        // ✅ Opposite gender top

        formatted = sortByOppositeGenderFirst(formatted);



        setChats(formatted);

      }

    })

    .catch((err) => console.error("Fetch users error:", err));

}, []);



  const getChatKey = (u1, u2) => {

    const sorted = [u1.id, u2.id].sort();

    return `chat_${sorted[0]}_${sorted[1]}`;

  };



  const openChat = (contact) => {

    if (!currentUser.canChat) {

      alert("🚫 Please get membership plan to use Chat feature!");

      navigate("/membership");

      return;

    }

    setActiveChat(contact);

    const key = getChatKey(currentUser, contact);

    const old = JSON.parse(localStorage.getItem(key)) || [];

    setMessages(old);

  };



  const callUser = (contact) => {

    if (!currentUser.canCall) {

      alert("🚫 Please get membership plan to use Call feature!");

      navigate("/membership");

      return;

    }

    if (!contact?.mobile) {

      alert("❌ Mobile number not available");

      return;

    }

    window.location.href = `tel:${contact.mobile}`;

  };





  



const sendMessage = async () => {

  if (!text.trim()) return;



  const key = getChatKey(currentUser, activeChat);



  const newMsg = {

    senderId: currentUser.id,

    text,

    time: new Date().toLocaleTimeString(),

  };



  const updated = [...messages, newMsg];

  setMessages(updated);

  localStorage.setItem(key, JSON.stringify(updated));

  setText("");



  try {

    await axios.post("https://rishtey.rishteymatch.in/api2/api/send-chat", {

      fromUserId: currentUser.id,

      toUserId: activeChat.id,

      message: text,

    });

  } catch (err) {

    console.error("Chat notification error", err);

  }

};













  // ✅ Toggle Like + Notify Backend + Animation

  const toggleLike = async (profile) => {

    const alreadyLiked = likedProfiles.find((p) => p.id === profile.id);

    const likeButton = document.querySelector(`#like-btn-${profile.id}`);

    

    // Add animation class

    if (likeButton) {

      likeButton.classList.add('heart-animation');

    }



    let updatedLikes;

    if (alreadyLiked) {

      // Unlike

      updatedLikes = likedProfiles.filter((p) => p.id !== profile.id);

    } else {

      // Like & send notification to backend

      updatedLikes = [...likedProfiles, profile];

      try {

        await axios.post("https://rishtey.rishteymatch.in/api2/api/send-like", {

          fromUserId: currentUser.id,

          toUserId: profile.id,

        });

      } catch (err) {

        console.error("Error sending like notification:", err);

      }

    }



    setLikedProfiles(updatedLikes);

    localStorage.setItem("likedProfiles", JSON.stringify(updatedLikes));



    // Remove animation class after animation completes (4 seconds)

    if (likeButton) {

      setTimeout(() => {

        likeButton.classList.remove('heart-animation');

      }, 4000);

    }

  };



const filteredChats = chats.filter((chat) => {

  const q = query.toLowerCase();

  const name = (chat.fullName || "").toLowerCase();

  const state = (chat.state || "").toLowerCase();

  const city = (chat.city || "").toLowerCase();

  const gender = (chat.gender || "").toLowerCase();



  const matchesQuery =

    name.includes(q) || state.includes(q) || city.includes(q);



  const matchesGender = genderFilter

    ? gender === genderFilter.toLowerCase()

    : true;



  return matchesQuery && matchesGender;

});





  



 const ImageModal = ({ imageUrl, onClose }) => (

  <div

    onClick={onClose}

    style={{

      position: "fixed",

      top: 0,

      left: 0,

      width: "100vw",

      height: "100vh",

      backgroundColor: "rgba(0,0,0,0.85)",

      display: "flex",

      alignItems: "center",

      justifyContent: "center",

      zIndex: 9999,

    }}

  >

    <img

      src={imageUrl}

      alt="Profile"

      style={{

        maxWidth: "90%",

        maxHeight: "90%",

        borderRadius: "12px",

        boxShadow: "0 0 20px rgba(255,255,255,0.3)",

      }}

      onClick={(e) => e.stopPropagation()}

    />



    <span

      onClick={onClose}

      style={{

        position: "absolute",

        top: "20px",

        right: "30px",

        fontSize: "32px",

        color: "#fff",

        cursor: "pointer",

        fontWeight: "bold",

      }}

    >

      ×

    </span>

  </div>

);







  if (activeChat)

    return (

      <div className="d-flex flex-column vh-100 bg-light">

        <div className="bg-dark text-white d-flex align-items-center p-3 shadow-sm">

          <button

            className="btn btn-dark me-3"

            onClick={() => setActiveChat(null)}

          >

            <i className="bi bi-arrow-left"></i>

          </button>

          <img

            src={activeChat.avatar || defaultAvatar}

            alt={activeChat.fullName}

            className="rounded-circle me-2 border border-2 border-white"

            width="45"

            height="45"

            onClick={() =>

              setFullscreenImage(activeChat.avatar || defaultAvatar)

            }

            style={{ cursor: "pointer" }}

          />

          <div>

            <strong>{activeChat.fullName}</strong>

            <div className="text-success" style={{ fontSize: "0.85rem" }}>

              🟢 Active Now

            </div>

          </div>

        </div>



        <div

          className="flex-grow-1 overflow-auto p-3"

          style={{ backgroundColor: "#f0f2f5" }}

        >

          {messages.map((msg, i) => (

            <div

              key={i}

              className={`d-flex mb-2 ${

                msg.senderId === currentUser.id

                  ? "justify-content-end"

                  : "justify-content-start"

              }`}

            >

              <div

                className={`p-2 rounded-3 shadow-sm ${

                  msg.senderId === currentUser.id

                    ? "bg-warning text-dark"

                    : "bg-white text-dark"

                }`}

                style={{ maxWidth: "70%" }}

              >

                <div>{msg.text}</div>

                <small

                  className="d-block text-end"

                  style={{ fontSize: "10px" }}

                >

                  {msg.time}

                </small>

              </div>

            </div>

          ))}

          <div ref={messagesEndRef} />

        </div>



        <div className="p-2 bg-white d-flex align-items-center border-top shadow-sm">

          <input

            type="text"

            className="form-control rounded-pill me-2"

            placeholder="Type a message..."

            value={text}

            onChange={(e) => setText(e.target.value)}

            onKeyDown={(e) => e.key === "Enter" && sendMessage()}

          />

          <button

            className="btn btn-warning rounded-circle"

            style={{ width: "45px", height: "45px" }}

            onClick={sendMessage}

          >

            <i className="bi bi-send-fill"></i>

          </button>

        </div>



        {fullscreenImage && (

          <ImageModal

            imageUrl={fullscreenImage}

            onClose={() => setFullscreenImage(null)}

          />

        )}

      </div>

    );



    

    



const shareOnWhatsApp = (profile) => {

  const pageUrl = `${window.location.origin}/moredetail/${profile.id}`;



  const message = `

🔗 *View Profile & Photo*

${pageUrl}

🧡 *Agrawal Rishtey Match*

👤 *Name:* ${profile.fullName}

🎂 *Age:* ${profile.age}

📍 *Address:* ${profile.city}, ${profile.state}

🎓 *Education:* ${profile.education}



🌐 https://rishteymatch.in/profile

  `.trim();



  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

  window.open(whatsappUrl, "_blank");

};









  // Profile list UI

  return (

    <>

     <div className="navbar-fixed">

  <Navbar />

</div>



     <div className="profile">

  {/* FIXED HEADER AREA */}

  <div className="profile-header">

    <div className="container py-3">

      



      <div className="mb-3 d-flex justify-content-center">

        <input

          type="text"

          placeholder="Search by name, state, or city..."

          className="form-control search-input"

          value={query}

          onChange={(e) => setQuery(e.target.value)}

        />

      </div>



      <div className="d-flex justify-content-center gap-2">

        {["", "Male", "Female"].map((gender) => (

          <button

            key={gender}

            className={`btn btn-sm ${

              genderFilter === gender

                ? "btn-warning"

                : "btn-outline-warning"

            }`}

            onClick={() => setGenderFilter(gender)}

          >

            {gender || "All"}

          </button>

        ))}

      </div>

         {/* Instagram-style Stories Section */}

    <div className="mt-2 ">

      {/* <div className=" ">

        <h6 className="text-white mb-0">Profile</h6>

      </div> */}

      <div className="stories-container">

        {/* Add Your Story */}

        {/* <div className="story-item" onClick={() => alert('Add your story feature coming soon!')}>

          <div className="story-ring">

            <div className="add-story-overlay">

              <i className="bi bi-plus-lg"></i>

            </div>

          </div>

          <div className="story-username">Your Story</div>

        </div> */}

        

        {/* Profile Stories */}

        {filteredChats.slice(0, 8).map((chat) => (

          <div className="story-item" key={chat.id}>

            <div className="story-ring">

              <img

                src={chat.avatar || defaultAvatar}

                alt={chat.fullName}

                className="story-image"

                style={{ cursor: "pointer" }}

                onClick={() => setFullscreenImage(chat.avatar || defaultAvatar)}

              />

            </div>

            <div className="story-username">{chat.fullName.split(' ')[0]}</div>

          </div>

        ))}

      </div>

    </div>

    </div>

  </div>



  {/* SCROLLABLE CARDS AREA */}

  <div className="profile-content">

 



    {/* Original Profile Cards */}

    <div className="container">

      <div className="row g-3 mb-5 pb-4">

        {filteredChats.map((chat) => (

          <div

            className="col-12 col-sm-6 col-md-4 col-lg-3"

            key={chat.id}

          >

            <div className="profile-card">

              <div className="d-flex align-items-center mb-2 justify-content-between">

                <div className="d-flex align-items-center">

              <img

  src={chat.avatar || defaultAvatar}

  alt={chat.fullName}

  className="profile-img"

  style={{ cursor: "pointer" }}

  onClick={() => setFullscreenImage(chat.avatar || defaultAvatar)}

/>



                  <div>

                    <strong>{chat.fullName}</strong>

                    

                    <p className="mb-0 small">

                      {chat.state}, {chat.city}

                    </p>

                   

                  </div>

                  

                </div>



       <button

  id={`like-btn-${chat.id}`}

  className={`like-btn ${

    likedProfiles.some((p) => p.id === chat.id) ? "liked" : ""

  }`}

  onClick={() => toggleLike(chat)}

>

  <span className="heart-icon">❤️</span>

</button>



              </div>



            <div className="d-flex gap-2 mt-2">

  <button

    className="btn btn-sm flex-grow-1 btn-outline-warning"

    onClick={() => callUser(chat)}

  >

    <i class="bi bi-telephone-fill"></i> Call

  </button>



  <button

    className="btn btn-sm flex-grow-1 btn-outline-danger text-light"

    onClick={() => openChat(chat)}

  >

   <i class="bi bi-chat-dots-fill"></i> Chat

  </button>



  <button

    className="btn btn-sm flex-grow-1 btn-outline-primary text-light"

    onClick={() =>

      navigate(`/moredetail/${chat.id}`, { state: chat })

    }

  >

    🔍 More

  </button>



  {/* ✅ SHARE BUTTON */}

  <button

    className="btn btn-sm flex-grow-1 btn-outline-warning"

    onClick={() => shareOnWhatsApp(chat)}

  >

   <i class="bi bi-share-fill"></i>

  </button>

</div>



            </div>

          </div>

        ))}



        {filteredChats.length === 0 && (

          <p className="text-white text-center mt-4">

            No active profiles found

          </p>

        )}

      </div>

    </div>

  </div>

</div>





      {fullscreenImage && (

        <ImageModal

          imageUrl={fullscreenImage}

          onClose={() => setFullscreenImage(null)}

        />

      )}



      <Footer />

    </>

  );

};



export default Moreprofile;

